import React from 'react';
import { CTAButton } from '../CTAButton';
import { UrgencyBlock } from '../UrgencyBlock';
export function FinalCta() {
  return <section className="bg-ink px-4 py-14 sm:px-6 sm:py-20" data-id="element-115" data-mp="22cksoz4pane3">
      <div className="mx-auto w-full max-w-2xl text-center" data-id="element-116" data-mp="1nphroih65wm0">
        <h2 className="font-display text-[26px] font-bold leading-[1.15] text-cream sm:text-4xl" data-id="element-117" data-mp="1nmvkijy6xj4b">
          Pronto a smettere di improvvisare e iniziare a diagnosticare con un
          sistema?
        </h2>
        <p className="mx-auto mt-3 max-w-lg text-[15px] leading-relaxed text-cream/65" data-id="element-118" data-mp="1eqnyl231rod7">
          Inizia oggi stesso a pianificare riabilitazioni complesse con maggiore
          sicurezza e fiducia.
        </p>

        <div className="mx-auto mt-8 max-w-md" data-id="element-119" data-mp="19p6xb5gnhzw3">
          <CTAButton label="Voglio il Protocollo Clinico Sicuro" note="Solo 19 € · Download immediato · Accesso a vita · Garanzia di 7 giorni" data-id="element-120" data-mp="19q01pzs50db2" />
        </div>

        <div className="mx-auto mt-7 max-w-md" data-id="element-121" data-mp="341wvhze1xv9a">
          <UrgencyBlock showSpots={false} showCurrency={false} data-id="element-122" data-mp="294x82hbk9ql" />
        </div>
      </div>
    </section>;
}